<div class="warp-no-result empty" *ngIf="isEmpty==true ; else filter">
  <svg-icon svgClass="svg-img" src="/assets/images/messages/empty.svg"></svg-icon>
  <ng-container *ngIf="type=='group' else otherTypes">
    <p class="title" translate>no-result.group.not-found</p>
    <div class="btn color" (click)="create()" *ngIf="isRoleAdmin$()">
      <p translate>no-result.group.create</p>
    </div>
  </ng-container>
</div>
<ng-template #filter>
  <div class="warp-no-result" *ngIf="!isData ; else data">
    <svg-icon svgClass="svg-img" src="/assets/images/messages/no-result.svg"></svg-icon>
    <p class="title" translate>no-result.not-found</p>
    <p class="text" translate>no-result.try</p>
    <div *ngIf="type !='approvals'" class="btn color" (click)="reset()">
      <p translate>no-result.reset-filter</p>
    </div>
    <div *ngIf="type =='approvals' && (!downloadRecordsTab$())" class="btn color" (click)="resetApprovals()">
      <p translate>no-result.reset-filter</p>
    </div>
  </div>
</ng-template>

<ng-template #otherTypes>
  <ng-container *ngIf="type=='questionnaire'">
    <p class="title"
      *ngIf="isRoleAdmin$() && !selectedfilter$()?.myQuestionnaires && !selectedfilter$()?.generalQuestionnaires"
      translate>no-result.questionnaire.not-found</p>
    <p class="title"
      *ngIf="!isRoleAdmin$() || selectedfilter$()?.myQuestionnaires || selectedfilter$()?.generalQuestionnaires"
      translate>no-result.questionnaire.not-found-to-user</p>
    <div class="btn color" (click)="create()"
      *ngIf="isRoleAdmin$() && !selectedfilter$()?.myQuestionnaires && !selectedfilter$()?.generalQuestionnaires">
      <p translate>no-result.questionnaire.create</p>
    </div>
  </ng-container>
  <ng-container *ngIf="type=='reminder'">
    <p class="title" translate>no-result.reminder.not-found</p>
    <div class="btn color" (click)="create()" *ngIf="isRoleAdmin$()">
      <p translate>no-result.reminder.create</p>
    </div>
  </ng-container>
  <ng-container *ngIf="type=='approvals'">
    <p *ngIf="pendingApprovalTab$()" class="title" translate>
      no-result.approvals.not-found</p>
    <p *ngIf="afterApprovalTab$()" class="title" translate>
      no-result.approvals.not-found-history</p>
    <p *ngIf="downloadRecordsTab$()" class="title" translate>
      no-result.approvals.not-found-approved</p>
  </ng-container>
  <ng-container *ngIf="type=='reports'">
    <p class="title" translate>no-result.reports.not-found</p>
  </ng-container>
</ng-template>

<ng-template #data>
  <div class="warp-no-result" [ngClass]="{'full':!noCommentsForPage}">
    <svg-icon class="margin-bottom" svgClass="svg-img" src="/assets/images/messages/no-replay.svg"></svg-icon>
    <ng-container *ngIf="noCommentsForPage; else noAnswers">
      <p class="title" translate>no-result.data.no-comments-for-page</p>
    </ng-container>
    <ng-template #noAnswers>
      <p class="title" translate>no-result.data.no-answers</p>
      <p class="text" translate>no-result.data.try</p>
      <div class="btn color" (click)="create()" *ngIf="isRoleAdmin$()">
        <p translate>no-result.reminder.send</p>
      </div>
    </ng-template>
  </div>
</ng-template>